<template>
    <b-container fluid style="background-color: white; padding: 7px;">
        <h4 class="text-themecolor">Aantal ({{ count }})</h4>
        <b-table v-if="windowSize < 992" class="table-invoices d-table d-lg-none" 
            id="table-small"
            hover
            outlined
            no-border-collapse
            show-empty
            :items="invoicerecognitiondata"
            :fields="fieldsSmall"
            ref="invoiceRecognitionDataTable"
            selectable
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :select-mode="selectMode"
            :busy="count == -1"
            primary-key="documentId"
            @row-selected="onRowSelected"
            @row-clicked="expandAdditionalInfo"
            @filtered="onFiltered">
                <template v-slot:cell(selected)="{rowSelected}">
                    <template v-if="rowSelected">
                        <span aria-hidden="true"><i class="fas fa-long-arrow-alt-right"></i></span>
                        <span class="sr-only">{{$t('invoicerecognition.geselecteerd')}}</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">{{$t('invoicerecognition.nietGeselecteerd')}}</span>
                    </template>
                </template>
               <template v-slot:cell(documentId)="row">{{ row.item.documentId }}</template>
                <template v-slot:cell(customerId)="row">{{ row.item.customerId }}</template>
                <template v-slot:cell(documentType)="row">{{ row.item.documentType }}</template>
                <template v-slot:cell(confidence)="row">{{ row.item.confidence }}</template>
                <template v-slot:cell(additionalInfoIcon)="row">
                    <i v-show="!row.item._showDetails" class="fas fa-chevron-down"></i>
                    <i v-show="row.item._showDetails" class="fas fa-chevron-up"></i>
                </template>
                <template v-slot:row-details="row">
                    <b-card>
                        <InvoiceRecognitionDetail
                                v-bind:selectedDocumentId="row.item.documentId"
                                v-bind:selectedId="row.item.id"
                                v-bind:row="row"
                                @nextDocument="toDocument($event)"
                                @previousDocument="toDocument($event)"
                                @documentValidation="setValidation($event)"/>
                    </b-card>
                </template>
                <template v-slot:table-busy>
                    <PreLoader/>
                </template>
        </b-table>
        <b-table v-if="windowSize >= 992" class="table-invoices d-none d-lg-table" 
            id="table-small"
            hover
            outlined
            no-border-collapse
            show-empty
            :items="invoicerecognitiondata"
            :fields="fieldsLarge"
            ref="invoiceRecognitionDataTable"
            selectable
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :select-mode="selectMode"
            :busy="count == -1"
            primary-key="documentId"
            @row-selected="onRowSelected"
            @row-clicked="expandAdditionalInfo"
            @filtered="onFiltered">
                <template v-slot:cell(selected)="{rowSelected}">
                    <template v-if="rowSelected">
                        <span aria-hidden="true"><i class="fas fa-long-arrow-alt-right"></i></span>
                        <span class="sr-only">{{$t('invoicerecognition.geselecteerd')}}</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">{{$t('invoicerecognition.nietGeselecteerd')}}</span>
                    </template>
                </template>
                <template v-slot:cell(documentId)="row">{{ row.item.documentId }}</template>
                <template v-slot:cell(customerId)="row">{{ row.item.customerId }}</template>
                <template v-slot:cell(administrationId)="row">{{ row.item.administrationId }}</template>
                <template v-slot:cell(fileName)="row">{{ row.item.filename }}</template>
                <template v-slot:cell(createdAt)="row">{{ row.item.createdAt | date }}</template>
                <template v-slot:cell(documentType)="row">{{ row.item.documentType }}</template>
                <template v-slot:cell(confidence)="row">{{ row.item.confidence }}</template>
                <template v-slot:cell(additionalInfoIcon)="row">
                    <i v-show="!row.item._showDetails" class="fas fa-chevron-down"></i>
                    <i v-show="row.item._showDetails" class="fas fa-chevron-up"></i>
                </template>
                <template v-slot:row-details="row">
                    <b-card>
                        <InvoiceRecognitionDetail
                                v-bind:selectedDocumentId="row.item.documentId"
                                v-bind:selectedId="row.item.id"
                                v-bind:row="row"
                                @nextDocument="toDocument($event)"
                                @previousDocument="toDocument($event)"
                                @documentValidation="setValidation($event)"/>
                    </b-card>
                </template>
                <template v-slot:table-busy>
                    <PreLoader/>
                </template>
        </b-table>
        <b-row>
            <b-col>
                <b-col align-self="center" sm="8" md="6" lg="9" class="my-1">
                    <b-form-group label-cols-sm="5" label-cols-lg="3" :label="$t('invoicerecognition.aantalItems')"  label-for="perPageSelect">
                        <b-form-select
                                v-model="perPage"
                                id="perPageSelect"
                                size="md"
                                :options="pageOptions">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-col>
            <b-col v-if="windowSize >= 992" align-self="center" sm="5" md="6" class="my-1 fm d-none d-md-block">
                <b-pagination
                        class="customPagination"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :first-text="$t('invoicerecognition.eerste')"
                        :next-text="$t('invoicerecognition.volgende')"
                        :next-class="nextPageClass"
                        :last-text="$t('invoicerecognition.laatste')"
                        :prev-text="$t('invoicerecognition.vorige')"
                        :prev-class="prevPageClass"
                        align="center"
                        size="md"
                ></b-pagination>               
            </b-col>
            <b-col v-if="windowSize < 992" align-self="center" sm="5" md="6" class="my-1 fm d-xs-block d-sm-block d-md-none">
                <b-pagination
                        class="customPagination"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :next-class="nextPageClass"
                        :prev-class="prevPageClass"
                        align="center"
                        size="md"
                ></b-pagination>                
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InvoiceRecognitionDetail from "./InvoiceRecognitionDetail";
    import { mapGetters, mapActions } from "vuex";
    import $ from "jquery";
    import { uuidMixin } from '@/mixins/uuidMixin';
    import IsValidatedCommand from "./isValidatedCommand";
    import PreLoader from '@/components/root/Preloader';

    export default {
        name: "invoice-recognition-index",
        mixins: [ uuidMixin ],
        components: {InvoiceRecognitionDetail, PreLoader},
        data() {
            return {
                search: '',
                rowIndex: 1,
                command: {},
                count: -1,
                windowSize: $(window).width(),
                selectedInvoiceId: null,
                page: 1,
                itemsPerPage: 8,
                currentPage: 1,
                perPage: 15,
                nextPageClass: "next-page-button",
                prevPageClass: "prev-page-button",
                pageOptions: [5, 10, 15, 25, 100, 250],
                sortBy: 'documentId',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                profile: this.$auth.profile,
                selectMode: 'single',
                selected: []
            }
        },
        computed: {
            ...mapGetters('fmmodule',['invoicerecognitiondata']),
            numberOfPages () {
                return Math.ceil(this.invoicerecognitiondata.length / this.itemsPerPage)
            },
            fieldsLarge (){
                return [
                    { key: 'selected', label: "#", tdClass: 'pr-0 pl-0' },
                    { key: 'documentId', label: this.$t('invoicerecognition.documentid'), sortable: true },
                    { key: 'customerId', label: this.$t('invoicerecognition.klantid'), sortable: true },
                    { key: 'administrationId', label: this.$t('invoicerecognition.administratieid'), sortable: true },
                    { key: 'fileName', label: this.$t('invoicerecognition.bestandsnaam'), sortable: true, tdClass: 'pr-0 pl-0' },
                    { key: 'createdAt', label: this.$t('invoicerecognition.aanmaakdatum'), sortByFormatted: true, filterByFormatted: true, sortable: true, tdClass: 'pr-0 pl-0' },
                    { key: 'documentType', label: this.$t('invoicerecognition.documenttype'), sortable: true, sortDirection: 'desc' },
                    { key: 'confidence', label: this.$t('invoicerecognition.zekerheid'), sortable: true, tdClass: 'pr-0 pl-0' },
                    { key: 'additionalInfoIcon', label: '', tdClass: 'pr-0 pl-0'}
                ]
            },
            fieldsSmall (){
                return [
                    { key: 'selected', label: "#", tdClass: 'pr-0 pl-0' },
                    { key: 'documentId', label: this.$t('invoicerecognition.documentid'), sortable: true },
                    { key: 'customerId', label: this.$t('invoicerecognition.klantid'), sortable: true },
                    { key: 'documentType', label: this.$t('invoicerecognition.documenttype'), sortDirection: 'desc' },
                    { key: 'confidence', label: this.$t('invoicerecognition.zekerheid'), tdClass: 'pr-0 pl-0' },
                    { key: 'additionalInfoIcon', label: '', tdClass: 'pr-0 pl-0'}
                ]
            },            
            rows() {
                return this.invoicerecognitiondata.length
            }
        },
        methods: {
            ...mapActions('fmmodule',['all', 'update']),
            nextPage () {
                if (this.page + 1 > this.numberOfPages) {
                    $("#nextPageButton").prop("disabled", true);
                } else {
                    this.page += 1;
                    $("#previousPageButton").prop("disabled", false);
                }
            },
            expandAdditionalInfo(row) {
                var rowShowDetails = row._showDetails
                var vm = this;
                var store = this.$store;
                
                this.invoicerecognitiondata.forEach(function(element) {
                    vm.showDetails(store, element, false)
                });
                                
                this.showDetails(this.$store, row, !rowShowDetails)
            },
            showDetails(store, element, showDetails) {
                    var elementPatch = {
                        _showDetails: showDetails
                    }   

                    store.commit('fmmodule/update', {
                        resource: "invoicerecognition/unvalidated",
                        result: { ...element, ...elementPatch }
                    })
            },
            previousPage () {
                if (this.page - 1 >= 1) {
                    this.page -= 1
                    $("#nextPageButton").prop("disabled", false);
                } else {
                    $("#previousPageButton").prop("disabled", true);
                }
            },
            updateItemsPerPage (number) {
                this.itemsPerPage = number
            },
            showAllItems () {
                if ($('#mobileFooter:visible').length == 0) {
                    this.updateItemsPerPage(this.invoicerecognitiondata.length);
                } else {
                    this.updateItemsPerPage(8);
                }
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            onRowSelected(items) {
                this.selected = items
            },
            calculatePageNumber(itemsPerPage, itemIndex) {
                const pageNumber = Math.ceil(itemIndex / itemsPerPage)
                const totalPages = Math.ceil(this.invoicerecognitiondata.length / itemsPerPage)
                if(pageNumber > totalPages) {
                    return totalPages
                }
                return pageNumber
            },
            async toDocument( direction ) {
                const table = document.querySelector(`.table-invoices.b-table-selecting tbody`)
                const selectedItems = table.querySelectorAll('tr[aria-selected="true"]')
                const itemsPerPage = this.perPage
                const currentPage = this.currentPage
                const totalItems = this.totalRows

                if(selectedItems.length > 0) {
                    const selectedItemIndex = parseInt(selectedItems[0].ariaRowIndex)
					let newItemIndex = selectedItemIndex

                    if (isNaN(selectedItemIndex)) { return }
					if(direction !== 'nextWithPositiveOrNegative') {
						newItemIndex = direction === 'next' ? selectedItemIndex + 1 : selectedItemIndex - 1
					}

                    if(newItemIndex > 0 && newItemIndex <= totalItems) {
                        const newItemPage = this.calculatePageNumber(itemsPerPage, newItemIndex)
                        if(currentPage !== newItemPage) {
                            this.currentPage = newItemPage
                            await this.$nextTick()
                        }
						await this.$nextTick()
                        $('[aria-rowindex="' + newItemIndex + '"]').trigger('click')
                    } else {
                        this.$refs.invoiceRecognitionDataTable.clearSelected()
                    }
                }
            },
            setValidation(currentInvoiceRecognitionItem) {
                const vm = this;

                const payload = {
                    resource: "invoicerecognition",
                    params: new IsValidatedCommand(currentInvoiceRecognitionItem)
                }

                vm.update(payload)
            },
            onResize() {
                this.windowSize = $(window).width();
            }                                    
        },
        watch: {
            invoicerecognitiondata: function(value) {
                this.count = value.length;
            }
        },
        created() {
            var vm = this;
            vm.all({
                resource: 'invoicerecognition/unvalidated',
                queryParameters: [
                    {key: '$top', value: 250},
                    {key: '$count', value: true},
                    {key: '$orderby', value: 'documentId%20asc'}
                ]
            }).then(() => {
                    vm.totalRows = vm.invoicerecognitiondata.length;
            });
            window.addEventListener('resize', this.onResize)
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize)
        }         
    }
</script>
<style scoped>
    .headerItems{
        text-align: center;
    }

    ::v-deep.customPagination > li.active > a,
    ::v-deep.customPagination > li > a:hover {
        color: white;
        background-color: #7abd59;
        border: 1px solid grey;
    }

    @-webkit-keyframes rotationOpen {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(180deg);
        }
    }

    @-webkit-keyframes rotationClose {
        from {
            -webkit-transform: rotate(180deg);
        }
        to {
            -webkit-transform: rotate(0deg);
        }
    }

    @media only screen and (max-width: 510px) {
        #pagingMenu{
            margin-top: 10%;
        }

        #desktopHeader{
            display: none;
        }

        #mobileFooter {
            display: none;
        }
    }
</style>